// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3gHNP","fileBtn":"File_fileBtn__SczL4","closeBtn":"File_closeBtn__3FKi0","fileSelected":"File_fileSelected__2AXMx","disabled":"File_disabled__3y7xK"};